import {
  IRegistryParameters,
  IComponentLoader,
  IHostContext,
} from '../../registry.types';

export function registerComponents<
  TComponentModel,
  TParts extends Extract<keyof TComponentModel, string> = never,
>(
  components: Record<string, IComponentLoader<TComponentModel, TParts>>,
  context: IHostContext,
  {
    registerComponent,
    registerLibrary,
  }: Pick<
    IRegistryParameters<TComponentModel, TParts>,
    'registerComponent' | 'registerLibrary'
  >,
) {
  const { library, manifest, assets } = context;

  if (Object.keys(components).length) {
    if (registerComponent) {
      Object.keys(components).forEach(componentName => {
        const loader = components[componentName];
        registerComponent(componentName, loader, library.artifactId);
      });
    }

    if (registerLibrary) {
      registerLibrary(library.artifactId, components, [
        ...assets,
        ...manifest.assets,
      ]);
    }
  }
}
